<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>
 
<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import appointments from '@/services/api/appointments.api'
import specialistApi from '@/services/api/specialist.api'
import providerApi from '@/services/api/provider.api'
import locationApi from '@/services/api/location.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'
import ROLE from '@/utils/role'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Citas de Evaluaciones Coordinadas',
      routes: ['Informes', 'Citas de Evaluaciones Coordinadas'],
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          specialists: [],
          months: [],
          providers: [],
          billingCenters: [],
        },
        filters: {
          academicYear: null,
          specialist: null,
          month: null,
          provider: null,
          billingCenter: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          clearable: false,
          class: 'col-md-4',
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'billingCenter',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'CSEE Facturación',
          placeholder: 'Seleccionar',
          clearable: false,
          class: 'col-md-4',
          options: this.model.search.collections.billingCenters,
          value: this.model.search.filters.billingCenter,
          disabled: this.model.search.collections.billingCenters.length <= 0,
          onChanged: this.onChangeBillingCenter,
        },
        {
          name: 'provider',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Proveedor',
          placeholder: 'Seleccionar',
          options: this.model.search.collections.providers,
          value: this.model.search.filters.provider,
          class: 'col-md-4',
          disabled:
            this.model.search.collections.providers.length <= 1,
          onChanged: this.onChangeProvider,
        },
        {
          name: 'specialist',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Especialista',
          placeholder: 'Seleccionar',
          error: 'El especialista es requerido.',
          clearable: false,
          options: this.model.search.collections.specialists,
          value: this.model.search.filters.specialist,
          class: 'col-md-4',
          disabled: this.model.search.collections.specialists.length <= 1,
        },
        {
          name: 'month',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Periodo',
          placeholder: 'Seleccionar',
          error: 'Los meses son requeridos.',
          validations: 'required',
          clearable: false,
          options: this.model.search.collections.months,
          value: this.model.search.filters.month,
          class: 'col-md-4',
          disabled: this.model.search.collections.months.length <= 0,
        },
      ]
    },
  },
  async mounted() {
    this.applyInitProviderRole();
    await this.setFilters()
  },
  methods: {
    hasValue(param) {
      return param !== null && param !== undefined
    },
    async setFilters() {
      await AcademicYearServices.getExistingPeisAcademicYears().then((res) => {
        this.model.search.collections.academicYears = res.data
        let years = (this.model.search.filters.academicYear = res.data.filter(
          (x) => x.selected
        ))
        this.model.search.filters.academicYear =
          years.length > 0 ? years[0] : null
      })
      if (this.model.search.filters.academicYear != null) {
        this.onChangeAcademicYear()
      }
    },
    async onChangeAcademicYear() {
      this.model.search.filters.month = null;
      if (!this.applyInitProviderRole()) {
        this.model.search.filters.provider = null
      }
      this.model.search.filters.billingCenter = null;

      await this.getMonth();
      await this.getBillingCenter();
    },
    async onChangeBillingCenter() {
      await this.getProvider()
    },
    async onChangeProvider() {
      this.model.search.filters.specialist = null

      await this.getSpecialist()
    },
    async onHandlerSearch() {
      this.process()
    },
    async getSpecialist() {
      await specialistApi
        .getSpecialistProvider({
          academicYearId: this.model.search.filters.academicYear?.id,
          companyId: this.model.search.filters.provider?.id,
        })
        .then((res) => {
          this.model.search.collections.specialists = res.data;

          if (this.model.search.collections.specialists.length == 1) {
            this.model.search.filters.specialist = res.data[0];
          }
        })
    },
    async getMonth() {
      await appointments
        .getAppointmentsFilters({
          academicYearId: this.model.search.filters.academicYear?.id,
        })
        .then((res) => {
          this.model.search.collections.months = res.data
        })
    },
    applyInitProviderRole() {
      const isProviderRole = this.userRole == ROLE.Provider
        || this.userRole == ROLE.AsistenteProveedor;
      const hasOnlyOneCompany = this.userCompanies.length == 1;
      if (isProviderRole && hasOnlyOneCompany) {
        this.model.search.filters.provider = this.userCompanies[0];
        this.getSpecialist();
      }

      return isProviderRole && hasOnlyOneCompany;
    },
    async getProvider() {
      if (this.applyInitProviderRole()) return;

      const res = await providerApi.getProviderByYearAndCenter(
        this.model.search.filters.academicYear?.id,
        this.model.search.filters.billingCenter?.id
      );
      
      const userCompanyIds = this.userCompanies.map(x => x.id);
      const availableCompanies = this.userRole == ROLE.Provider ?
      res.data.filter(x => userCompanyIds.includes(x.id))
      : res.data;

      this.model.search.collections.providers = availableCompanies;

      if (availableCompanies.length == 1) {
        this.model.search.filters.provider = availableCompanies[0]
        await this.getSpecialist()
      }
    },
    async getBillingCenter() {
      await locationApi
        .getBillingCenters({
          academicYearId: this.model.search.filters.academicYear?.id,
        })
        .then((res) => {
          this.model.search.collections.billingCenters = res.data
          if (this.model.search.collections.billingCenters.length == 1) {
            this.model.search.filters.billingCenter = this.model.search.collections.billingCenters[0]
            this.getProvider()
          }
        })
    },
    async process() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        )
        return
      }

      await ReportServices.getReport(
        'reportappointmentscoordinatedevaluations',
        {
          academicYearId: this.model.search.filters.academicYear?.id,
          companyId: this.model.search.filters.provider?.id,
          centerId: this.model.search.filters.billingCenter?.id,
          month: this.model.search.filters.month?.id,
          specialistId: this.model.search.filters.specialist?.id,
        }
      ).then((res) => DocumentServices.Download(res.data))
    },
  },
}
</script>
